/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeeTerritoriesAddComponent
 * Purpose		: This component allows to create new EmployeeTerritories record and save changes.
 * Dependency	: EmployeeTerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit,
	HostBinding, trigger, transition, animate,
	style, state } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { EmployeeTerritoriesData, EmployeeTerritoriesService } from './EmployeeTerritories.service';
import { EmployeesData, EmployeesService } from '../Employees/Employees.service';
import { TerritoriesData, TerritoriesService } from '../Territories/Territories.service';


@Component({
	selector: 'my-EmployeeTerritories-add',
	template: require('./EmployeeTerritoriesAdd.component.html'),
	providers: [EmployeeTerritoriesService
		, EmployeesService, TerritoriesService
		],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class EmployeeTerritoriesAddComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objEmployeeTerritories: EmployeeTerritoriesData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	
	EmployeesList: EmployeesData[];
	TerritoriesList: TerritoriesData[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
	private toastr: ToastsManager,
    private EmployeeTerritoriesService: EmployeeTerritoriesService
			, private  EmployeesService:  EmployeesService
			, private  TerritoriesService:  TerritoriesService

	) {
		this.objEmployeeTerritories = new EmployeeTerritoriesData();
	}

	ngOnInit() {
		this.objEmployeeTerritories = new EmployeeTerritoriesData();
		this.getLookups();
	}

	addEmployeeTerritories() {
		this.EmployeeTerritoriesService.addEmployeeTerritoriesData(this.objEmployeeTerritories)
			.subscribe(record => this.router.navigate(['/EmployeeTerritories']),
			error =>  this.errorMessage = 'There was an error while adding record. Error: ' + <any>error,
			() => { 
				this.toastr.success('EmployeeTerritories record added successfully...', 'Add EmployeeTerritories');
				console.log('EmployeeTerritories record added successfully...'); 
			}
		);
	}

	gotoEmployeeTerritories() {
		// let Id = this.objEmployeeTerritories ? this.objEmployeeTerritories.EmployeeID : null;
		this.router.navigate(['/EmployeeTerritories']);
	}

	// Get Lookup List for Employees
    getEmployees() {
		this.EmployeesService.getAll().subscribe(records => this.EmployeesList=records);
    }
	// Get Lookup List for Territories
    getTerritories() {
		this.TerritoriesService.getAll().subscribe(records => this.TerritoriesList=records);
    }

	getLookups() {

        this.getEmployees();
        this.getTerritories();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/EmployeeTerritories/EmployeeTerritoriesAdd.component.ts